/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type RoleDropdown_roles = ReadonlyArray<{
    readonly node: {
        readonly name: string | null;
        readonly id: string;
    } | null;
    readonly " $refType": "RoleDropdown_roles";
}>;
export type RoleDropdown_roles$data = RoleDropdown_roles;
export type RoleDropdown_roles$key = ReadonlyArray<{
    readonly " $data"?: RoleDropdown_roles$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"RoleDropdown_roles">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "RoleDropdown_roles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoleTypeEdge"
};
(node as any).hash = '49d6e05bfe0a411559b89059c240ec10';
export default node;
